import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateService } from '@uirouter/core';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromShared from './store';
import { Process } from './store/process.model';
// import { AppComponent } from '../../app.component';

@Component({
    selector: 'ef-process',
    templateUrl: './process.component.html',
    styleUrls: ['./process.component.scss'],
    standalone: false
})
export class ProcessComponent implements OnInit {
    constructor(
        private log: LoggingService,
        private ss: StateService,
        private store: Store<fromShared.State>
    ) {}

    @Input() public process: Process;
    @Input() public catId: number;
    public disabled: boolean;

    ngOnInit() {
        this.disabled = !this.process.RouteName;
        // this.log.verbose({type: 'ProcessComponent:ngOnInit', process: this.process, disabled: this.disabled});
    }

    public goto(process: Process) {
        this.store.dispatch(fromShared.clearProcess());
        this.store.dispatch(fromShared.upsertProcess({ process }));
        const stateName =
            process?.RouteName?.toLowerCase().replace('/', '.') ?? 'main';
        this.log.debug({ type: 'ProcessComponent:goto', process, stateName });
        this.ss.go(stateName, { process: { ...process, catId: this.catId } });
        // this.app.onMenuButtonClick(null);
    }
}
